<template>
  <div>
    <div class="fixed inset-x-0 top-0 z-20">
      <div class="bg-white/90 backdrop-blur supports-[backdrop-filter]:bg-white/80">
        <div class="h-1 bg-gradient-to-r from-amber-500 to-amber-200"></div>
        <div class="flex items-center px-4 py-4">
          <div class="flex items-center w-full">
            <a @click="$router.go(-1)"><img src="@/assets/back-arrow.svg" alt=""></a>
            <span class="text-base text-content font-medium ml-4">Enquiry Details</span>
          </div>
        </div>
      </div>
    </div>
    <div class="pt-16 ">
      <div class="p-5 bg-gray-50 ">
        <h3 class="text-main font-semibold text-xs   mb-4">Contact Details</h3>
        <div class="rounded-2xl bg-white/90 shadow-sm ring-1 ring-black/5 p-5 mb-4">
          <div class="grid gap-3 grid-cols-2 ">
          <div>
            <span class="block text-xs text-slate-500 mb-2">Name</span>
            <span class="block text-sm text-slate-800">{{enquiryDetails.name}}</span>
          </div>
          <div class="">
            <span class="block text-xs text-slate-500 mb-2">Enquiry Status</span>
            <span
              class="inline-flex items-center gap-1 px-2 py-1 rounded font-medium text-xs cursor-pointer transition bg-slate-100 text-main hover:bg-slate-200">{{enquiryDetails.status}}</span>
          </div>
          <div>
            <span class="block text-xs text-slate-500 mb-2">Email</span>
             <a class="block text-sm text-slate-800 break-words" :href="enquiryDetails.email && `mailto: ${enquiryDetails.email}`">{{enquiryDetails.email || '-'}}</a>
          </div>
          <div>
            <span class="block text-xs text-slate-500 mb-2">Mobile</span>
              <div :class="{disabled : !enquiryDetails.mobile}">
            <a class="block text-sm text-slate-800" @click="enquiryDetails.ctoc_enabled ? makeCall(enquiryDetails.uuid)  : logCallAttempt(`tel:${enquiryDetails.mobile}`)">
              
              {{enquiryDetails.mobile || '-'}}
            </a>
          </div>
          </div>
        </div>
    
        </div>
        <div class="rounded-2xl bg-white/90 shadow-sm ring-1 ring-black/5 p-1 mb-4 text-center call-loading-holder" v-if="gifCallStatus">
          <img width="100%" height="auto"  :src="gifCallStatus">
      </div>
      <h3 class="text-main font-semibold text-xs   mb-4">Property Details</h3>
      <div class="rounded-2xl bg-white/90 shadow-sm ring-1 ring-black/5 p-5 mb-4">
        <div class="grid gap-3 grid-cols-2">
        <div v-if="enquiryDetails.preferred_project_id">
          <span class="block text-xs text-slate-500 mb-2">Preferred Project</span>
          <span class="block text-sm text-slate-800">{{enquiryDetails.preferred_project}}</span>
        </div>
        <div v-if="enquiryDetails.preferred_property_id">
          <span class="block text-xs text-slate-500 mb-2">Preferred Property</span>
          <span class="block text-sm text-slate-800">{{enquiryDetails.preferred_property}}</span>
        </div>
        <div>
          <span class="block text-xs text-slate-500 mb-2">Property For</span>
          <span class="block text-sm text-slate-800">{{leadKeysList.custom_label_property_for & enquiryDetails.transaction_type_id === 'Rental' ? 'Resale' : enquiryDetails.transaction_type_id}}</span>
        </div>
        <div>
          <span class="block text-xs text-slate-500 mb-2">Building Type</span>
          <span class="block text-sm text-slate-800">{{enquiryDetails.building_type || '-'}}</span>
        </div>
        <div>
          <span class="block text-xs text-slate-500 mb-2">Property Type</span>
          <span class="block text-sm text-slate-800">{{enquiryDetails.property_type || '-'}}</span>
        </div>
        <div>
          <span class="block text-xs text-slate-500 mb-2">Configuration</span>
          <span class="block text-sm text-slate-800">{{enquiryDetails.configuration}}</span>
        </div>
        <div>
          <span class="block text-xs text-slate-500 mb-2">Possession by</span>
          <span class="block text-sm text-slate-800">{{enquiryDetails.possession_by}}</span>
        </div>
        <div>
          <span class="block text-xs text-slate-500 mb-2">Possession Status</span>
          <span class="block text-sm text-slate-800">{{enquiryDetails.possession_status}}</span>
        </div>
        <div>
          <span class="block text-xs text-slate-500 mb-2">Expected Price</span>
          <span class="block text-sm text-slate-800">{{priceinLacs(enquiryDetails.budget)}}</span>
        </div>
        <div>
          <span class="block text-xs text-slate-500 mb-2">City</span>
          <span class="block text-sm text-slate-800">{{enquiryDetails.city}}</span>
        </div>
        <div class="col-span-full">
          <span class="block text-xs text-slate-500 mb-2">Localities</span>
          <span class="block text-sm text-slate-800">{{enquiryDetails.localities}}</span>
        </div>
        <div>
          <span class="block text-xs text-slate-500 mb-2">Sources</span>
          <span class="block text-sm text-slate-800">{{enquiryDetails.display_source}}</span>
        </div>
        <div v-if="enquiryDetails.closing_executive">
          <span class="block text-xs text-slate-500 mb-2">Closing Executive</span>
          <span class="block text-sm text-slate-800">{{enquiryDetails.closing_executive_name}}</span>
        </div>
        <div v-if="cpSourceIds.includes(enquiryDetails.source_id)">
          <span class="block text-xs text-slate-500 mb-2">Channel Partner</span>
          <span class="block text-sm text-slate-800">{{enquiryDetails.broker}}</span>
        </div>
        <div v-if="plan_ids.includes(enquiryDetails.status_id)">
          <span class="block text-xs text-slate-500 mb-2">Tentitive visit plan date</span>
          <span class="block text-sm text-slate-800">{{enquiryDetails.formatted_tentative}}</span>
        </div>
        <div>
          <span class="block text-xs text-slate-500 mb-2">NCD</span>
          <span class="block text-sm text-slate-800">{{enquiryDetails.formatted_ncd}}</span>
        </div>
        <div>
          <span class="block text-xs text-slate-500 mb-2">Assigned to</span>
          <span class="block text-sm text-slate-800">{{enquiryDetails.user}}</span>
        </div>


        <div>
          <span class="block text-xs text-slate-500 mb-2">Furnishings</span>
          <span class="block text-sm text-slate-800">{{enquiryDetails.require_furnishing}}</span>
        </div>
        <div>
          <span class="block text-xs text-slate-500 mb-2">Bathrooms</span>
          <span class="block text-sm text-slate-800">{{enquiryDetails.no_of_bathroom}}</span>
        </div>
        <div>
          <span class="block text-xs text-slate-500 mb-2">No of Parkings</span>
          <span class="block text-sm text-slate-800">{{enquiryDetails.no_of_parkings}}</span>
        </div>
        <div>
          <span class="block text-xs text-slate-500 mb-2">Floor Range</span>
          <span class="block text-sm text-slate-800">{{enquiryDetails.floor_range}}</span>
        </div>
        <div>
          <span class="block text-xs text-slate-500 mb-2">Facing Direction</span>
          <span class="block text-sm text-slate-800">{{enquiryDetails.facing_direction}}</span>
        </div>
        <div v-if="deadStatusIds.includes('' + enquiryDetails.status_id)">
          <span class="block text-xs text-slate-500 mb-2">Dead Reason</span>
          <span class="block text-sm text-slate-800">{{enquiryDetails.dead_reason}}</span>
        </div>
        <div v-if="(enquiryDetails.visits || []).length > 0">
          <span class="block text-xs text-slate-500 mb-2">Total Visits</span>
          <span class="block text-sm text-slate-800 " @click="modal_visit_details = true">{{enquiryDetails.visits.length}} Visit(s)</span>
        </div>
        <div v-for="(item,index) in enquiryDetails.magic_field_values" :key="index">
            <div class="col-span-2" v-if="item.value">
            <span class="block text-xs text-slate-500 mb-2">{{item.label_name}}</span>
            <span class="block text-sm text-slate-800">{{item.value}}</span>
            </div>
          </div>
        <div class="col-span-2">
          <span class="block text-xs text-slate-500 mb-2">Description</span>
          <ReadMore more-str="read more" :text="enquiryDetails.comments" v-if="enquiryDetails.comments" less-str="read less" :max-chars="50"></ReadMore>
        </div>
        </div>
      </div>

      </div>
      
       <div class="pb-5 px-5 bg-gray-50 ">
          <div class="flex items-center justify-center gap-3">
							
            <router-link :to="{ name: 'EditEnquiry',  params: {  uuid: this.$route.params.uuid }}" class="text-content text-xs font-medium text-opacity-50 flex items-center gap-2 flex-col justify-center rounded-xl bg-white/90 shadow-sm ring-1 ring-black/5 p-4 min-w-20 w-full">
       <Edit class="size-5" /> Edit 
    </router-link>

									<a  @click="showVisitModal = true"
										class="text-white text-xs font-medium  flex items-center gap-2 flex-col justify-center rounded-xl bg-primary shadow-sm ring-1 ring-black/5 p-4 min-w-20 w-full">
										<Add class="size-5" /> Add Visit
									</a>
								
								</div>
        </div>
        
              
          <Modal v-model="modal_visit_details" header="Total visit">
            <div class="flex flex-col bg-white py-2">
              <div v-for="(visit, key) in enquiryDetails.visits" :key="key">
                 <div class="flex  border-b border-main border-opacity-20 mb-5  ">
                    <div class="w-full">
                    <div class="col-span-2">
                      <span class="block text-xs text-slate-500 mb-2">Project Name</span>
                      <span class="block text-sm text-slate-800">{{visit.projects}}</span>
                    </div>
                    <div class="col-span-2">
                      <span class="block text-xs text-slate-500 mb-2">Properties Name</span>
                      <span class="block text-sm text-slate-800">{{visit.properties}}</span>
                    </div>
                    <div class="col-span-2">
                      <span class="block text-xs text-slate-500 mb-2">Date</span>
                      <span class="block text-sm text-slate-800">{{visit.date}}</span>
                    </div>
                      <div class="col-span-2">
                        <span class="block text-xs text-slate-500 mb-2">Description</span>
                        <span class="block text-sm text-slate-800" v-html="visit.comment"></span>
                      </div>

                    </div>
                      <div class="w-1/4 flex justify-end">
                		<span class=" text-main text-opacity-50 "  @click="deleteVisit(visit)"><svg  class="stroke-current " width="16" height="16" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path d="M11.8125 3.0625L2.1875 3.06254" stroke="" stroke-linecap="round" stroke-linejoin="round"/>
											<path d="M5.6875 5.6875V9.1875" stroke="" stroke-linecap="round" stroke-linejoin="round"/>
											<path d="M8.3125 5.6875V9.1875" stroke="" stroke-linecap="round" stroke-linejoin="round"/>
											<path d="M10.9375 3.0625V11.375C10.9375 11.491 10.8914 11.6023 10.8094 11.6844C10.7273 11.7664 10.616 11.8125 10.5 11.8125H3.5C3.38397 11.8125 3.27269 11.7664 3.19064 11.6844C3.10859 11.6023 3.0625 11.491 3.0625 11.375V3.0625" stroke="" stroke-linecap="round" stroke-linejoin="round"/>
											<path d="M9.1875 3.0625V2.1875C9.1875 1.95544 9.09531 1.73288 8.93122 1.56878C8.76712 1.40469 8.54456 1.3125 8.3125 1.3125H5.6875C5.45544 1.3125 5.23288 1.40469 5.06878 1.56878C4.90469 1.73288 4.8125 1.95544 4.8125 2.1875V3.0625" stroke="" stroke-linecap="round" stroke-linejoin="round"/>
											</svg>
                    </span>
                    </div>
                 </div>
              </div>
              <div class="flex justify-end space-x-2">
                  <button @click="modal_visit_details = false" class="text-sm text-main text-opacity-50">Close</button>
              </div>
            </div>
        </Modal>
          <Modal v-model="showVisitModal" header="Add visit">
            <div class="flex flex-col bg-white py-2">
              <div class="mb-6 relative">
                <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Project</label>
                  <Multiselect v-model="leadParams.projects" :searchable="true" :placeholder="propertyNoInput"
                  label="name" valueProp="id" mode="tags" :options="projectList"
                  :taggable="true" @search-change="suggestProject" class="multiselect-outer-wrapper" />
              </div>
              <div class="mb-6 relative">
                <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Properties</label>
                  <Multiselect v-model="leadParams.properties" :searchable="true" :placeholder="propertyNoInput"
                  label="project_name" valueProp="id" mode="tags" :options="propertiesList"
                  :taggable="true" @search-change="suggestProperty" class="multiselect-outer-wrapper" />
              </div>
              <div class="mb-6 relative">
                <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Visit Date</label>
                <input type="date" v-model="leadParams.visitDate" required class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto focus:outline-none">
              </div>
              <div class="mb-6 relative">
                <label for=""
                  class="text-main text-opacity-80 text-sm block mb-2 bg-white">Comment</label>
                <textarea v-model="leadParams.visitComment" rows="3" placeholder="Comment"
                  class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto focus:outline-none"></textarea>
              </div>
              <div class="flex justify-end space-x-2">
                  <button @click="updateLead" class="text-sm border-primary text-primary  px-6 py-3 rounded-xl   bg-primary bg-opacity-10 mr-4">Submit</button>
                  <button @click="showVisitModal = false" class="text-sm font-medium text-main text-opacity-50">Close</button>
              </div>
            </div>
        </Modal>
        
    </div>
  </div>
</template>
<script>
import Multiselect from '@vueform/multiselect'
import Modal from '@/components/Common/Modal.vue'
import {numDifferentiation, prepareUpdateParams} from '@/assets/scripts/utility.js';
import Add from '@/components/icons/Add.vue';
import Edit from '@/components/icons/Edit.vue';
export default {
  components: {
    Modal,
    Multiselect,
    Add,
    Edit
  },
  data () {
    return {
      callStatus: null,
      phoneCall: {connected: require('@/assets/connected.gif'), dialing: require('@/assets/dialing.gif'), failed: require('@/assets/failed.gif')},
      enquiryDetails: {},
      modal_visit_details: false,
      showVisitModal: false,
      propertiesList: [],
      projectList: [],
      propertyNoInput: 'Start Typing....',
      leadParams: {
        visitDate: null,
        visitComment: null,
        projects: [],
        properties: []
      },
    }
  },
  created(){
    this.$store.dispatch('setnewEnquiryData', {});
    this.loadEnquiryDetails()
  },
  computed: {
    cpSourceIds() {
      return this.$store.getters.cpIds;
    },
    plan_ids() {
      return this.$store.getters.plan_ids;
    },
    leadKeysList(){
      return this.$store.getters.leadKeys;
    },
    deadStatusIds() {
      return this.$store.getters.deadStatusIds;
    },
    gifCallStatus() {
      if (this.callStatus == 'dialing') {
        return this.phoneCall.dialing
      } else if (this.callStatus == true) {
        return this.phoneCall.connected
      } else if (this.callStatus == false) {
        return this.phoneCall.failed
      } else {
        return ''
      }
    }
  },
  methods: {
    logCallAttempt(location){
      this.$axios
      .post(`mobile_crm/leads/${this.enquiryDetails.uuid}/log_call_attempt`)
      .then((res) => {
        window.location= location
      })
      .catch((err) => {
        window.location= location
      });
    },
    makeCall(uuid) {
      this.callStatus = 'dialing'
      this.$axios.post(`mobile_crm/leads/make_call`, { uuid: uuid }).then((res) => {
        this.callStatus = res.data.success
      });
    },
    suggestProject(event) {
      if (event.length === 3) {
        event = encodeURIComponent(event)
        this.$axios.get(`/mobile_crm/leads/search_projects?search_string=${event.trim()}`)
          .then(res => {
            this.propertyNoInput = "No Results!"
            if (res.data.projects.length > 0) {
              this.projectList = res.data.projects
            }
          })
          .catch(err => {
            this.propertyNoInput = "Something Went Wrong!"
          })
      }
    },
    suggestProperty(event) {
      if (event.length === 3) {
        event = encodeURIComponent(event)
        this.$axios.get(`/mobile_crm/leads/search_properties?search_string=${event.trim()}`)
          .then(res => {
            this.propertyNoInput = "No Results!"
            if (res.data.properties.length > 0) {
              this.propertiesList = res.data.properties
            }
          })
          .catch(err => {
            this.propertyNoInput = "Something Went Wrong!"
          })
      }
    },
    priceinLacs(value) {
      return numDifferentiation(value)
    },
    deleteVisit(visit) {
      this.$swal.fire({
        title: "Are you sure?",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          this.$axios
            .delete(`mobile_crm/leads/${this.enquiryDetails.uuid}/visits/${visit.id}`)
            .then((res) => {
              let index = this.enquiryDetails.visits.indexOf(visit);
              this.enquiryDetails.visits.splice(index, 1);
              this.$swal.fire({
                title: "Visit Deleted!",
                icon: "success",
              });
            })
            .catch((err) => {
              if (err.response.status === 500) {
                this.$swal.fire({
                  title: "Server Error!",
                  icon: "error",
                });
              } else {
                this.$swal.fire({
                  title: "Error",
                  text: err.response.data.message,
                  icon: "error",
                });
              }
            });
        }
      });
    },
    updateLead() {
      let updateP = prepareUpdateParams(this.leadParams);
      if (Object.keys(updateP).length > 0) {
        this.$axios
          .put(`mobile_crm/leads/${this.enquiryDetails.uuid}`, { lead: updateP })
          .then((res) => {
            this.enquiryDetails = res.data.lead;
            for (let key in this.leadParams) {
              this.leadParams[key] = null;
            }
            this.showVisitModal = false
            this.$swal.fire({
              title: "Updated!",
              icon: "success",
            });
          })
          .catch((err) => {
            if (err.response.status === 500) {
              this.$swal.fire({
                title: "Server Error!",
                icon: "error",
              });
            } else {
              this.$swal.fire({
                title: "Error",
                text: err.response.data.message,
                icon: "error",
              });
            }
          });
      }
    },
    loadEnquiryDetails(){
      this.$axios.get(`mobile_crm/leads/${this.$route.params.uuid}`)
        .then((res) => {
        this.enquiryDetails = res.data.lead
      })
      .catch((err) => console.log(err));
    }
  },
}
</script>